import { NavigationProjects } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { type WithIdProps, withId } from "@src/components/HOC/with-id/withId";
import { ProjectsInvoicingPlan } from "@src/components/modules/projects/billing-plan";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Invoicing plan`}
    navigation={<NavigationProjects projectId={id} />}
    scrollToTopButton
  >
    <ProjectsInvoicingPlan id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/projects/invoicing-plan")({
  component: RouteComponent,
});
